import * as React from 'react'
import { PaginatedPayment } from '@getgreenline/homi-shared'
import { ExpandablePayment } from '../../../../components/ExpandablePayment'
import { BlazepayEnums, BlazepayPaymentOptionModels } from '@getgreenline/payments'

interface Props {
  paginatedPayments: PaginatedPayment
  currentEmployeeId: string
  search: () => void
  canEdit: boolean
  canRefund: boolean
  canEditCustomer: boolean
  paymentOptions?: Map<
    BlazepayEnums.Provider,
    BlazepayPaymentOptionModels.IPaymentOptionEventOrRestData
  >
}

export const PaymentTable = (props: Props) => {
  const {
    paginatedPayments,
    currentEmployeeId,
    search,
    canEdit,
    canRefund,
    canEditCustomer,
    paymentOptions,
  } = props

  return (
    <div className='table-responsive'>
      <table className='table table-hover'>
        <thead className='thead-light'>
          <tr>
            <th>ID</th>
            <th>Complete Date</th>
            <th>Source</th>
            <th>Device</th>
            <th>Payment</th>
            <th>Employee</th>
            <th>Customer</th>
            <th>Notes</th>
            <th className='text-right'>Barcode</th>
            <th className='text-right'>Total</th>
            <th className='text-right'>Status</th>
          </tr>
        </thead>
        <tbody>
          {paginatedPayments.payments.map((payment) => {
            return (
              <ExpandablePayment
                key={payment.id}
                payment={payment}
                currentEmployeeId={currentEmployeeId}
                onUpdate={search}
                canEdit={canEdit}
                canRefund={canRefund}
                canEditCustomer={canEditCustomer}
                paymentOptions={paymentOptions}
              />
            )
          })}
        </tbody>
      </table>
      <br />
    </div>
  )
}
